import { render } from "./AboutServer.vue?vue&type=template&id=0b9761ce"
import script from "./AboutServer.vue?vue&type=script&lang=js"
export * from "./AboutServer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__